import { useSelector } from 'react-redux';

export const APP_NAME = process.env.APP_NAME;
export const USER_SESSION = 'user';
export const ACCESS_TOKEN = 'accessToken';
export const AUTH = 'authUser';
export const MESSAGE = 'customMessage';
export const EXPIRED_SESSION = 'expiredsession';
export const DEVICE_ID = 'deviceId';

export const API_CONFIGURATION = () => {
    return {
        apiURL: process.env.REACT_APP_API_URL + '/api',
        authURL: process.env.REACT_APP_API_URL + '/auth',
        apiHeaders: {
            'Cache-Control': 'max-age=31536000',
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/vnd.certuit-v1.0.0+json'
        },
        apiAutenticatedHeaders: {
            Accept: 'application/vnd.certuit-v1.0.0+json',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
        },
        apiHeadersPost: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
            'Cache-Control': 'max-age=31536000'
        },
        API_AUTENTICATION_HEADERS: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/vnd.certuit-v1.0.0+json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem(ACCESS_TOKEN)
        },
        API_MULTIPART_HEADERS: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/vnd.certuit-v1.0.0+json',
            'Content-Type': 'multipart/form-data'
        }
    };
};
